<template>
  <b-row v-if="parentPath && path" style="height:100%;">
    <b-col md="12" style="height:100%;">
      <b-card
        v-tooltip="tooltipText"
        :style="{
          backgroundColor: coloreSfondo,
          color: coloreTesto,
          borderColor: coloreBordo
        }"
        class="card-panel"
        style="height:100%; margin-bottom: 0px !important"
      >
        <!--
        <div slot="header" :style="{ color: coloreTitolo, backgroundColor: coloreBarraTitolo }">
          {{ uniTranslation("Q1114") }}
        </div>
        -->
        <div
          v-if="localPath == '.left'"
          slot="header"
          :style="{ color: coloreTitolo, backgroundColor: coloreBarraTitolo }"
        >
          <!-- Primary Side -->
          {{ uniTranslation("PHE821") }}
        </div>
        <div
          v-if="localPath == '.right'"
          slot="header"
          :style="{ color: coloreTitolo, backgroundColor: coloreBarraTitolo }"
        >
          <!-- Secondary Side -->
          {{ uniTranslation("PHE822") }}
        </div>
        <!-- == MODIFICHE DA LASCIARE DIVERSE == -->

        <el-checkbox v-model="showFluidFlow">{{ uniTranslation("TRNSL42") }}</el-checkbox>

        <div v-if="showFluidFlow">
          <UnidataEditor :parent-path="path" :name="'.flow'"></UnidataEditor>
        </div>

        <UnidataEditor :parent-path="path" :name="'.saturationPressure'"></UnidataEditor>

        <UnidataEditor :parent-path="path" :name="'.saturationTemperature'"></UnidataEditor>

        <UnidataEditor :parent-path="path" :name="'.subcooling'"></UnidataEditor>

        <UnidataEditor :parent-path="path" :name="'.superheating'"></UnidataEditor>

        <UnidataEditor :parent-path="path" :name="'.pressureDrop'"></UnidataEditor>

        <UnidataEditor :parent-path="path" :name="'.foulingFactor'"></UnidataEditor>

        <!-- == MODIFICHE DA LASCIARE DIVERSE == -->
        <!--
        <UnidataEditor :parent-path="path" :name="'.fluidVelocityLiquidPhase'"></UnidataEditor>
        -->
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
// import FluidPicker from "../shared/FluidPicker";
import UnidataEditor from "../unidata/UnidataEditor";
// import UnidataEditorCorrelatorOptionList from "../unidata/UnidataEditorCorrelatorOptionList";
import { mapGetters } from "vuex";
import { Checkbox } from "element-ui";
// import { Radio, Collapse, CollapseItem } from "element-ui";
// import jsonHelper from "../../shared/jsonHelper";

export default {
  components: {
    // FluidPicker,
    UnidataEditor,
    "el-checkbox": Checkbox /*,
    UnidataEditorCorrelatorOptionList,
    "el-radio": Radio,
    "el-collapse": Collapse,
    "el-collapse-item": CollapseItem*/
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      path: null,
      showFluidFlow: false, // <!-- == MODIFICHE DA LASCIARE DIVERSE == -->
      coloreSfondo: "",
      coloreTesto: "",
      coloreBarraTitolo: "",
      coloreTitolo: "",
      coloreSfondoTab: "",
      coloreTestoTab: "",
      coloreBordo: ""
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"]),
    ...mapGetters("_colorsModule", ["cardColors"]),

    tooltipText() {
      var tmpPath = this.localPath;
      if (tmpPath.includes(".left")) {
        //Primary Side
        return this.uniTranslation("PHE821", "en-US");
      }
      if (tmpPath.includes(".right")) {
        //Secondary Side
        return this.uniTranslation("PHE822", "en-US");
      }
      return this.uniTranslation("S430", "en-US");
    }
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    }
  },
  mounted: function() {
    var that = this;
    if (this.parentPath && this.localPath) this.path = this.parentPath + this.localPath;
    that.coloreSfondo = that.cardColors[0] + " !important"; // 7 elementi. 0=sfondo 1=barra titolo 2=testo 3=colore titolo 4= sfondo tab 5=testo tab 6=testo titolo tab quando selezionata
    that.coloreBarraTitolo = that.cardColors[1];
    that.coloreTesto = that.cardColors[2];
    that.coloreTitolo = that.cardColors[3];
    that.coloreSfondoTab = that.cardColors[4];
    that.coloreTestoTab = that.cardColors[5];
    that.coloreBordo = that.cardColors[6];
  },
  methods: {
    /*...mapActions([
        'increment'
      ])*/
  }
};
</script>

<style lang="scss"></style>

<!--
<style lang="scss">

div{
  hr{
    margin-bottom: 10px;
    margin-top: 0;
  }
  .radio-unidata{
    display:flex;
    flex-direction: row;
    .radio-container{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-top: 25px;
      padding-left: 10px;
      width:160px;
      label{
        margin-bottom: 0px;
      }
      .el-radio + .el-radio{
        margin-left: 0px
      }
    }
  }
}


</style>
-->
